<div class="stripes">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
<div class="sign-in">
    <div class="sign-in__layout mt-8">
        <sl-auth *ngIf="initialized" [api]="passportApiUrl" 
            (authenticate)="onAuthenticate($any($event).detail)" 
            sign-in-header="Welcome to Previsto" i18n-sign-in-header 
            [signInDescription]="signInDescription"
            [email]="invitation?.email"
            [preventEmailChange]="invitation != null"
            [terms]="termsUrl"
            [allowUsernameLogin]="invitation == null"
            ></sl-auth>
    </div>
</div>